import React from 'react';

import { type KebabKeys } from '../types';

export interface OCConnectWidgetProps {
  slotId: string;
}
export interface OCConnectWidgetAttributes extends KebabKeys<Omit<OCConnectWidgetProps, 'className'>> {}

export const OCConnectWidget = (props: OCConnectWidgetProps) => {
  return (
    <div data-testid="oc-connect-widget-div">
      <oc-connect-widget slot-id={props.slotId}></oc-connect-widget>
    </div>
  );
};
